<form class="kLoginForm" [formGroup]="_resetPasswordForm" (submit)="_resetPassword($event)">
  <h1>{{ 'app.login.passwordExpired.title' | translate }}</h1>

  <div>
    <input
      pInputText
      appPreventPasswordAutofill
      type="password"
      autocomplete="off"
      [placeholder]="'app.login.passwordExpired.placeholder.current' | translate"
      [formControl]="_oldPasswordField"
      [class.has-error]="_showError(_oldPasswordField) || _oldPasswordWrong"
      [kTooltip]="_getClientValidationMessage(_oldPasswordField) | translate"
      placement="right"
    />
  </div>

  <div>
    <input
      pInputText
      appPreventPasswordAutofill
      type="password"
      autocomplete="off"
      [placeholder]="'app.login.passwordExpired.placeholder.new' | translate"
      [formControl]="_newPasswordField"
      [class.has-error]="_showError(_newPasswordField) || _passwordsDontMatch || _passwordStructureInvalid"
      [kTooltip]="_getClientValidationMessage(_newPasswordField) || _passwordStructureInvalidMessage | translate"
      placement="right"
    />
  </div>

  <div>
    <input
      pInputText
      appPreventPasswordAutofill
      type="password"
      autocomplete="off"
      [placeholder]="'app.login.passwordExpired.placeholder.confirm' | translate"
      [formControl]="_repeatPasswordField"
      [class.has-error]="_showError(_repeatPasswordField) || _passwordsDontMatch"
      [kTooltip]="_getClientValidationMessage(_repeatPasswordField) | translate"
      placement="right"
    />
  </div>

  <p
    *ngIf="(_repeatPasswordField.touched || _formSent) && _showError(_passwords)"
    class="kErrorMessage"
    [innerHTML]="_getClientValidationMessage(_passwords) | translate"
  ></p>
  <p
    *ngIf="
      errorMessage &&
      !_passwordStructureInvalid &&
      errorCode !== 'LOGIN_BLOCKED' &&
      errorCode !== 'LOGIN_RETRIES_EXCEEDED'
    "
    class="kErrorMessage"
    [innerHTML]="errorMessage"
  ></p>
  <p *ngIf="errorCode === 'LOGIN_BLOCKED'" class="kErrorMessage">
    {{ 'app.login.error.loginBlocked.loginDenied' | translate }}
    <a *ngIf="_supportAddress" (click)="_contactSupport()">{{ _supportAddress }}</a>
    {{ 'app.login.error.loginBlocked.toUnblockYourAccount' | translate }}
  </p>
  <p *ngIf="errorCode === 'LOGIN_RETRIES_EXCEEDED'" class="kErrorMessage">
    {{ 'app.login.error.retriesExceeded.yourAccountHasBeenLocked' | translate }}
    <a *ngIf="_supportAddress" (click)="_contactSupport()">{{ _supportAddress }}</a>
    {{ 'app.login.error.retriesExceeded.toUnblockYourAccount' | translate }}
  </p>

  <div>
    <button class="kButtonDefault" pButton [label]="_sendBtnText | translate" [disabled]="inProgress"></button>
  </div>
</form>
